import React from 'react';

import {inject, observer} from 'mobx-react';
import {
    WeaTop,
    WeaTab,
    WeaRightMenu,
    WeaErrorPage,
    WeaFormItem,
    WeaDialog,
    WeaSearchGroup,
    WeaSelect,
    WeaTree,
    WeaProgress,
    WeaAlertPage,
    WeaLocaleProvider,
} from 'ecCom';
import {WeaTableNew} from 'comsMobx';
import {Row, Col, Icon, Button, Spin} from 'antd';
import * as mobx from 'mobx';
import '../style/total.less';
import {InfoGroup4Formal1} from '../coms/infoGroup4Formal';
import {i18n} from '../public/i18n';
import Tabs from "../coms/Tabs";
import findIndex from 'lodash/findIndex';

const toJS = mobx.toJS;
let _this;
const getLabel = WeaLocaleProvider.getLabel;
const {
    WeaTable
} = WeaTableNew;

@inject('hrmResourceTotal')
@observer
class HrmResourceTotal extends React.Component {
    constructor(props) {
        super(props);
        _this = this;
    }

    componentDidMount() {
        const {hrmResourceTotal} = this.props;
        const hrmId = this.props.params.hrmId || '';
        hrmResourceTotal.hrmId = hrmId;
        hrmResourceTotal.getHasRight();
    }

    renderCol = (cols) => {
        let idx = findIndex(cols, item => item.dataIndex === 'finish');
        idx != -1 && (cols[idx].render = (text, record) => {
            return <WeaProgress percent={record.finish === '' ? 0 : record.finish} strokeColor={record.finishspan}/>
        })
    }

    render() {
        const {hrmResourceTotal} = this.props;
        const {title, loading, verified, hasRight, dialogParams, tabConfig, getTabIndex, formTarget} = hrmResourceTotal;
        let {condition} = hrmResourceTotal;
        condition = toJS(condition)
        const {query} = this.props.location;
        const {
            conditionForm: form,
            conditionFormFields: fields
        } = formTarget;
        const tabProps = {
            tabConfig: tabConfig,
            tabChangeHandle: tabConfig.tabChangeHandle,
            activeTabInfo: {
                activeTabKey: tabConfig.activeTabKey,
                activeTabIndex: getTabIndex(tabConfig.tabs, tabConfig.activeTabKey)
            },
            store: hrmResourceTotal,
            conditionForm: form,
            conditionFormFields: fields,
            tabBtnDef: tabConfig.buttons
        }
        const scrollProps = {
            scroll: {
                y: 480
            }
        }
        console.log("dialogParams", dialogParams);
        console.log("tabProps", tabProps);
        if (verified && hasRight) {
            return (
                <div className='wea-hrm-resource-total'>
                    <WeaRightMenu datas={this.getRightMenu()} onClick={this.onRightMenuClick.bind(this)}>
                        <div style={query.fromcard ? {display: 'none'} : {display: ''}}>
                            <WeaTop
                                title={title()}
                                loading={loading}
                                icon={<i className='icon-coms-hrm'/>}
                                iconBgcolor='#217346'
                                buttons={[]}
                                buttonSpace={10}
                                showDropIcon={false}
                            >
                            </WeaTop>
                        </div>
                        <Row gutter={24}>
                            <Col span='12'>
                                <Row className='wea-hrm-resource-total-info'>

                                    {
                                        condition && condition.map((c, index) => {
                                            if (index == 0) {
                                                const colArr = [];
                                                c.items && c.items.forEach((obj, index) => {
                                                    colArr.push(<Row>
                                                        <Col className="wea-info-group-content-cell-label" span={6}>
                                                            {obj.label ? obj.label : <div>&nbsp;</div>}:
                                                        </Col>

                                                        <Col className="wea-info-group-content-cell-value" span={12}>
                                                            {obj.value}
                                                        </Col>
                                                        { obj.codeName ?
                                                            <Col className="wea-info-group-content-cell-value" span={6}>
                                                                <a onClick={() => this.onSelectHandle(obj, index)}>{getLabel(17463, '明细')}</a>
                                                            </Col>
                                                        :
                                                            <Col className="wea-info-group-content-cell-value" span={6}>
                                                            </Col>
                                                        }
                                                    </Row>)
                                                })
                                                return (
                                                    <Col span='24'>
                                                        {/* <InfoGroup4Formal1 className={'hrm-base-group-title'} items={c.items} title={c.title} showGroup={c.defaultshow}/> */}
                                                        <div className="wea-info-group">
                                                            <Row className="wea-info-group-title">
                                                                <Col span={24}>
                                                                    <div
                                                                        className='wea-info-group-title-info'>{c.title}</div>
                                                                </Col>
                                                            </Row>
                                                            <Row className="wea-info-group-content">
                                                                {colArr}
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                )
                                            }
                                        })
                                    }
                                </Row>
                            </Col>
                            <Col span='12'>
                                <Row className='wea-hrm-resource-total-info'>
                                    {
                                        condition && condition.map((c, index) => {
                                            if (index > 0) {
                                                return (
                                                    <Col span='24'>
                                                        <InfoGroup4Formal1 className={'hrm-base-group-title'}
                                                                           items={c.items} title={c.title}
                                                                           showGroup={c.defaultshow}/>
                                                    </Col>
                                                )
                                            }
                                        })
                                    }
                                </Row>
                            </Col>
                        </Row>

                    </WeaRightMenu>
                    <WeaDialog {...dialogParams} hasScroll={false}>
                        {
                            form != null && form.isFormInit &&

                            <Tabs {...tabProps}>
                                {
                                    dialogParams.cType === 'table'
                                        ?
                                        <WeaTable
                                            comsWeaTableStore={dialogParams.table}
                                            hasOrder={true}
                                            needScroll={true}
                                            getColumns={cols => this.renderCol(cols)}
                                            {...scrollProps}
                                        />
                                        :
                                        <WeaTree
                                            datas={hrmResourceTotal.toJS(dialogParams.treeData)}
                                            rowKey={'categoryid'}
                                        />
                                }
                            </Tabs>
                        }
                    </WeaDialog>
                </div>
            );
        }
        if (verified && !hasRight) {
            return (<WeaAlertPage>
                    <div style={{color: '#000'}}>
                        {i18n.message.authFailed()}
                    </div>
                </WeaAlertPage>
            )
        }
        return (
            <div></div>
        )
    }

    onSelectHandle(obj, index) {
        this.props.hrmResourceTotal.onSelectHandle(obj, index);
    }

    getRightMenu() {
        const arr = [{
            icon: <i className='icon-coms-ws'/>,
            content: i18n.button.search()
        }, {
            icon: <i className='icon-coms-task-list'/>,
            content: i18n.button.columnVisibleSetting()
        }
        ];
        return arr;
    }

    onRightMenuClick(key) {
        const {hrmResourceTotal} = this.props;
        switch (key) {
            case '0':
                //hrmResourceTotal.doSearch();
                break;
            case '1':
                //this.definedColumn();
                break;
        }
    }
}

export default HrmResourceTotal



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/Total.js